export default __webpack_public_path__ + "static/media/404.1f05b34b.webp";